import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { BehaviorSubject, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ProactiveAlertsPopupComponent } from '../components/dialogs/proactive-alerts-popup/proactive-alerts-popup.component';
import { DashboardKPI } from '../models/DashboardKPI.model';
import { GoogleAnalyticsEventsService } from './google-analytics-events.service';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {
  baseURL = environment.baseUrl;
  $loader = new BehaviorSubject<Boolean>(false);
  customerList = []
  filterValue ='';
  customerDataList$ = new Subject();
  action_set: any = [
    { count: null, title: 'Low ink level'},
    { count: null, title: 'System Errors'},
    { count: null, title: 'Maintenances'},
    { count: null, title: 'Firmware Updates'},
    { count: null, title: 'Targeted Actions'}
];
  isRefreshed = false;
  storedCustomerActions$ = new Subject();
  constructor(private http: HttpClient,
              private router: Router,
              private googleAnalyticsEventsService: GoogleAnalyticsEventsService,
              private dialog: MatDialog) { }

  setRefresh(flag) {
    this.isRefreshed = flag;
  }            

  setLoader(value: Boolean) {
   this.$loader.next(value);
  }

  get loading() {
    return this.$loader.getValue();
  }

  getKPICount() {
    return this.http.get<DashboardKPI>(this.baseURL + '/services/core/users/api/v1/reseller/kpi_data');
  }

  getCaseStatistics() {
    return this.http.get<any>(this.baseURL + '/services/case/api/v1/case_status_statistics')
  }

  getCustomerList() {
    return this.http.get<any>(this.baseURL + '/services/core/users/api/v1/get_customers')
  }

  getSitePreparationList() {
    return this.http.get<any>(this.baseURL + '/services/site_preparation/api/v1/site_preparations')
  }

  getPendingInvitesList() {
    return this.http.get<any>(this.baseURL + '/services/core/api/printos/v1/invitations?status=pending');
  }

  resendInvites(payload) {
    return this.http.post<any>(this.baseURL + '/services/core/api/printos/v1/invitations/resend_invitations', payload)
  }

  getEOIList() {
    return this.http.get<any>(this.baseURL + '/services/core/users/api/v1/dashboard_eois');
  }

  downloadReport(reportURL) {
    return this.http.get<Blob>(reportURL, {observe: 'response', responseType: 'blob' as 'json'});
  }

  getAssignedUsers() {
    return this.http.get<any>(this.baseURL + '/services/case/api/v1/case_assigned_users')
  }
  getCustomers(id) {
    return this.http.get<any>(this.baseURL + `/services/core/users/api/v1/customer_actions?id=${id}`).pipe(
      tap((res) => {
        this.storedCustomerActions$.next(res);
      })
    );;
  }
  showMoreProactiveLAlerts(customer) {
    var isCustomerDetail = false;
    // this.googleAnalyticsEventsService.emitEvent('reseller-portal', 'View action required for a customer in dashboard', `from dashboard | ${customer?.customer_id}`, null)
    const ref = this.dialog.open(ProactiveAlertsPopupComponent, {
      disableClose: true,
      height: 'auto',
      data: { customer ,isCustomerDetail},
      panelClass: 'global-dialog',
    })
    
    ref.afterClosed().subscribe(data => {
      if(data == 'reload') {
        this.isRefreshed = true
      }
    })
  }
  showMoreProactiveLAlerts1(index,customer, customerID) {
    var isCustomerDetail = true;
    // this.googleAnalyticsEventsService.emitEvent('reseller-portal', 'View action required for a customer in dashboard', `from dashboard | ${customer?.customer_id}`, null)
    this.dialog.open(ProactiveAlertsPopupComponent, {
      disableClose: true,
      height: 'auto',
      data: { customer ,isCustomerDetail,index, customerID},
      panelClass: 'global-dialog',
    })
  }
modifiedEventType(type, userReplaceable) {
    let typeNLowercase = type?.toLowerCase()
    switch(typeNLowercase) {
      case 'systemerrors':
        return 'System Error'
      case 'maintenance' :
        if(userReplaceable) {
          return 'User Maintenance'
        }
        return 'Service Maintenance'
      case 'fwupgrade':
        return 'Firmware Update'
      case  'targetedaction':
      return 'Targeted action'
      case 'LowInkLevel':
        return 'Low ink level'
        default:
          return type
    }

  }

  storeCustomerList(customers) {
   this.customerList = customers;
  }

  reDirectToCasePageWithParams(assignee) {
    this.googleAnalyticsEventsService.emitEvent('reseller-portal', 'Go to case list and filter by Assignee', `from dashboard | assignee: ${assignee}`, null)
    this.router.navigate(['cases'], {queryParams: { assignee: assignee}})
  }

  getInitails(str) {
    if(str) {
     var matches = str?.match(/\b(\w)/g);
     var acronym = matches?.join('').toUpperCase();
     if(!matches) {
      return str[0];
     }
     return acronym;
    }
   }

   getAlertsDetails(id,status){
     return this.http.get<any>(this.baseURL+`/services/seals/api/v1/alerts/new_customer_proactive_alerts?customer_id=${id}&duration_wise=${status}`)
   }

   updateCustomerList(data) {
     this.customerDataList$.next(data);
   }

   getCustomerOpenCaseCount(customerId) {
    return this.http.get<any>(this.baseURL + `/services/case/api/v1/customer_case_count?customer_id=${customerId}`)
  }

  updateWarranty(body, params) {
    return this.http.post<any>(this.baseURL + `/services/eoi/api/v1/update_s4_warranty?printer_survey_id=${params?.printer_survey_id}&shipment_date=${params?.shipment_date}`, body)
  }

  getWarrantyPendingList() {
    return this.http.get<any>(this.baseURL + `/services/eoi/api/v1/pending_warranty_updates`)
  }

  getWarrantyCompletedList() {
    return this.http.get<any>(this.baseURL + `/services/eoi/api/v1/completed_warranty_updates`)
  }

  getWarrantyPendingCount() {
    return this.http.get<any>(this.baseURL + `/services/eoi/api/v1/pending_warranty_updates_count`)
  }

 

}
